import utils from '../utils';
import ccutils from './ccutils';
let BANCONTACT = {};
let payform = ccutils.getPayForm();

const bancontactFormAvailable = $('#bancontactForm').length > 0;
const paymentForm = document.getElementById('payment-form');
const cardNumber = document.getElementById('bancontactcard.cardNumber');
const ccNumber = $('#bancontactcard\\.cardNumber');
const expiryMonth = $('#bancontactcard\\.expiryMonth');
const expiryYear = $('#bancontactcard\\.expiryYear');
const holderName = $('#bancontactcard\\.cardHolderName');
const keyBC = $('#adyenKey').text();

BANCONTACT.init = function () {
  const isAndroid = utils.isAndroid();

  if (bancontactFormAvailable && cardNumber) {
    //  There are issues for older android devices, so we don't activate masking for them.
    if (!isAndroid) {
      //  Attach plugin validation first.
      payform.cardNumberInput(cardNumber);
    } else {
      ccNumber.attr('maxlength', '19');
    }
    //  Update cc-type with every key press on the CC-Number field.
    cardNumber.addEventListener('input', ccutils.cleanCardNumberOnChange);
  }

  bindSubmitBancontact();
  bindRemoveActionsBancontact();
};

const bindSubmitBancontact = () => {
  $(paymentForm).bind('submit', function () {
    if ($(this).hasClass('submitted')) return false;
    const paymentMethod = $(
      'input[type="radio"][name="paymentMethod"]:checked'
    ).val();
    const activePanel = $('.accordion__panel.active');
    if (paymentMethod !== 'BC' || !bancontactFormAvailable || !cardNumber) {
      // Submit form if it's not credit card.
      return true;
    }

    //  Reset error message content
    activePanel.find('.js-adyenFormValidation .info__text').empty();

    //  Continue if Bancontact card is selected as payment method.
    //  Check if form is valid.
    let isFormValid = [];
    isFormValid.push(ccutils.validateCCardNumber(cardNumber));
    isFormValid.push(ccutils.validateCardOwner(holderName));
    isFormValid.push(ccutils.validateExpiryDate(expiryMonth, expiryYear));
    //  Create encrypted form field if validation is successful
    if (isFormValid.every(Boolean)) {
      activePanel.find('.js-adyenFormValidation').css('display', 'none');

      // Remove Adyen CC fields otherwise encrypted data is not generated correctly
      $('#card\\.cardNumber').remove();
      $('#card\\.cardHolderName').remove();
      $('#card\\.expiryMonth').remove();
      $('#card\\.expiryYear').remove();
      $('#card\\.cvcCode').remove();
      $('.adyengenerationtime').remove();

      // CSE key is coming from the ftl template.
      // Adyen CA -> Settings -> Users -> Choose the WS user -> Copy CSE key
      const EncryptedForm = adyen.encrypt.createEncryptedForm(
        paymentForm,
        keyBC,
        {}
      );
      EncryptedForm.createEncryptedField(EncryptedForm.encrypt());
      ccutils.setBancontactCardDataInRequest(
        cardNumber,
        holderName,
        expiryMonth,
        expiryYear
      );
      $(this).addClass('submitted');
      return true;
    } else {
      //  Show error panel
      ccutils.showGeneralError();
      $('.accordion__panel.active').find('.js-adyenFormValidation').fadeIn();
      ccutils.hideLoadingAnimationButton($('#editPaymentSubmit'));
      return false; // Do not submit if form is not valid.
    }
  });
};

const bindRemoveActionsBancontact = () => {
  $('.js-removeCardBC').bind('click', ccutils.removeBancontactCardClicked);

  $('#bancontactRemoveCardBtn').click(function () {
    const removeBtn = $(this);
    if (removeBtn.hasClass('disabled')) {
      return false;
    }
    removeBtn.addClass('disabled');
    const $cardToRemove = $('#modalRemoveBancontactCard').find(
      '.js-cardContainer'
    );
    let cardToRemoveRef = '';

    if ($cardToRemove.length > 0) {
      cardToRemoveRef = $cardToRemove.attr('data-cardReference');
    }

    //  AJAX call for removing the stored credit card.
    ccutils.removeCard(
      cardToRemoveRef,
      'BC',
      ccutils.bancontactCardRemoveSuccessCallback,
      ccutils.cardRemoveErrorCallback
    );
  });
};

export default BANCONTACT;
